import type { SVGProps } from "react";

export const QuoteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    {...props}
  >
    <path
      d="M6.8 0C7.22667 0 7.57333 0.133333 7.84 0.4C8.10667 0.666666 8.24 1.04 8.24 1.52C8.24 1.78667 8.16 2.13333 8 2.56L5.76 8.08C5.70667 8.18667 5.68 8.32 5.68 8.48C5.68 8.96 5.92 9.2 6.4 9.2H7.28C7.70667 9.2 8.05333 9.36 8.32 9.68C8.64 9.94667 8.8 10.2933 8.8 10.72V17.92C8.8 18.3467 8.64 18.72 8.32 19.04C8.05333 19.3067 7.70667 19.44 7.28 19.44H1.52C1.09333 19.44 0.72 19.3067 0.4 19.04C0.133333 18.72 0 18.3467 0 17.92V10.72C0 9.81333 0.106667 9.01333 0.32 8.32C0.533333 7.62666 0.853333 6.85333 1.28 6L3.52 1.36C4.05333 0.453332 4.8 0 5.76 0H6.8ZM14.16 10.72C14.16 9.81333 14.24 9.01333 14.4 8.32C14.6133 7.62666 14.9333 6.85333 15.36 6L17.68 1.36C18.16 0.453332 18.88 0 19.84 0H20.96C21.3867 0 21.7333 0.133333 22 0.4C22.2667 0.666666 22.4 1.04 22.4 1.52C22.4 1.78667 22.32 2.13333 22.16 2.56L19.84 8.08C19.7867 8.13333 19.76 8.26667 19.76 8.48C19.76 8.64 19.8133 8.8 19.92 8.96C20.08 9.12 20.2933 9.2 20.56 9.2H21.36C21.7867 9.2 22.1333 9.36 22.4 9.68C22.72 9.94667 22.88 10.2933 22.88 10.72V17.92C22.88 18.3467 22.72 18.72 22.4 19.04C22.1333 19.3067 21.7867 19.44 21.36 19.44H15.68C15.2533 19.44 14.88 19.3067 14.56 19.04C14.2933 18.72 14.16 18.3467 14.16 17.92V10.72Z"
      fill="#939FE5"
    />
  </svg>
);
